
<template>
  <div>
    <textarea ref="mycode" class="codesql"> </textarea>
  </div>
</template>
<script>
import "codemirror/theme/ambiance.css";
import "codemirror/lib/codemirror.css";
import "codemirror/addon/hint/show-hint.css";
let CodeMirror = require("codemirror/lib/codemirror");
require("codemirror/addon/edit/matchbrackets");
require("codemirror/addon/selection/active-line");
require("codemirror/mode/sql/sql");
require("codemirror/addon/hint/show-hint");
require("codemirror/addon/hint/sql-hint");
require("codemirror/addon/display/placeholder");
export default {
  data() {
    return {
      editor: null,
      value: "",
    };
  },
  props: {
    sqlStyle: {
      type: String,
      default: "default",
    },
    readOnly: {
      type: [Boolean, String],
    },
  },
  watch: {
    newVal() {
      if (this.editor) {
        this.$emit("changeTextarea", this.editor.getValue());
      }
    },
  },
  computed: {
    newVal() {
      if (this.editor) {
        return this.editor.getValue();
      } else {
        return "";
      }
    },
  },

  mounted() {
    let mime = "text/x-mariadb";
    //let theme = 'ambiance'//设置主题，不设置的会使用默认主题
    this.editor = CodeMirror.fromTextArea(this.$refs.mycode, {
      value: this.value,
      mode: mime, //选择对应代码编辑器的语言，我这边选的是数据库，根据个人情况自行设置即可
      indentWithTabs: true,
      smartIndent: true,
      lineNumbers: true,
      matchBrackets: true,
      cursorHeight: 1,
      lineWrapping: true,
      readOnly: this.readOnly,
      //theme: theme,
      // autofocus: true,
      extraKeys: { Ctrl: "autocomplete" }, //自定义快捷键
      hintOptions: {
        //自定义提示选项
        // 当匹配只有一项的时候是否自动补全
        completeSingle: false,
        // tables: {
        //     users: ['name', 'score', 'birthDate'],
        //     countries: ['name', 'population', 'size']
        // }
      },
      placeholder: `示例：SELECT user_id, event_nameFROM eventWHERE time between '2022-08-17' and '2022-08-18'LIMIT 10 为保证查询效率，建议使用 time 字段进行过滤，并避免使用SELECT *`
    });
    //代码自动提示功能，记住使用cursorActivity事件不要使用change事件，这是一个坑，那样页面直接会卡死
    this.editor.on("inputRead", () => {
      this.editor.showHint();
    });
  },
  methods: {
    setVal() {
      if (this.editor) {
        if (this.value === "") {
          this.editor.setValue("");
        } else {
          this.editor.setValue(this.value);
        }
      }
    },
    // 清空
    clearSql() {
      this.editor.setValue("");
    },
    changeVal(value) {
      this.editor.setValue(value);
    },
  },
};
</script>
<style scoped>
/*  */
.CodeMirror {
  color: black;
  direction: ltr;
  height: 195px !important;
  /* min-height: 195px !important;
  max-height: 300px !important; */
  line-height: 22px;
  border-top: 1px rgb(129, 125, 125) solid;
  border-bottom: 1px rgb(129, 125, 125) solid;
}

.CodeMirror-empty {
  color: #bbb !important;
}


/* .CodeMirror pre.CodeMirror-line, .CodeMirror pre.CodeMirror-line-like */
/* // 这句为了解决匹配框显示有问题而加 */
/* .CodeMirror-hints {
  z-index: 9999 !important;
} */
</style>



// WEBPACK FOOTER //
// src/views/customized-queries/components/SqlEditor.vue